module.exports = __webpack_public_path__ + "static/media/features-split-image-02.da1fa478.svg";